import { io } from 'socket.io-client';

let _socket = null;
let _getToken = null;

export function getSocket(token, getTokenFn) {
  if (getTokenFn) _getToken = getTokenFn;

  if (_socket) return _socket;

  if (!_getToken && !token) return null;

  const base = (process.env.REACT_APP_API_URL || '').replace(/\/api\/?$/, '');
  _socket = io(base, {
    path: '/socket.io',
    auth: async (cb) => {
      try {
        const t = _getToken ? await _getToken() : token;
        cb({ token: t });
      } catch {
        cb({ token: token || '' });
      }
    },
    transports: ['websocket', 'polling'],
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
    timeout: 20000,
  });

  // On server-forced disconnect (e.g. token expired), refresh token and reconnect.
  // For all other disconnects (ping timeout, transport close) socket.io auto-reconnects.
  _socket.on('disconnect', async (reason) => {
    if (reason === 'io server disconnect' && _getToken) {
      try {
        const newToken = await _getToken();
        _socket.auth = { token: newToken };
      } catch {}
      _socket.connect();
    }
  });

  return _socket;
}

export function disconnectSocket() {
  if (_socket) {
    _socket.disconnect();
    _socket = null;
  }
  _getToken = null;
}
